import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-gray-900 text-white py-8 sm:py-12 px-4 sm:px-6 lg:px-8" data-id="element-108">
      <div className="max-w-7xl mx-auto" data-id="element-109">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8" data-id="element-110">
          <div className="sm:col-span-2" data-id="element-111">
            <div className="flex items-center space-x-2 mb-4" data-id="element-112">
              <div className="flex items-center -space-x-1.5" data-id="element-113">
                <ChevronRightIcon className="w-4 h-4 text-white opacity-40" strokeWidth={3} data-id="element-114" />
                <ChevronRightIcon className="w-4 h-4 text-white opacity-60" strokeWidth={3} data-id="element-115" />
                <ChevronRightIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-116" />
              </div>
              <span className="text-xl sm:text-2xl font-bold" data-id="element-117">Canjee</span>
              <span className="px-2 py-0.5 text-xs font-medium bg-amber-400 text-amber-900 rounded-full" data-id="element-118">
                Próximamente
              </span>
            </div>
            <p className="text-gray-400 mb-4 text-sm sm:text-base" data-id="element-119">
              Canjee es una red privada de corredores inmobiliarios. Publica
              propiedades gratis y usa créditos para solicitar canjes reales. Si
              te rechazan, recuperas tu crédito automáticamente.
            </p>
            <p className="text-gray-400 text-sm" data-id="element-120">contacto@canjee.cl</p>
          </div>
          <div data-id="element-121">
            <h4 className="font-semibold mb-4 text-sm sm:text-base" data-id="element-122">
              Navegación
            </h4>
            <ul className="space-y-2" data-id="element-123">
              <li data-id="element-124">
                <button onClick={() => scrollToSection('inicio')} className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-125">
                  Inicio
                </button>
              </li>
              <li data-id="element-126">
                <button onClick={() => scrollToSection('como-funciona')} className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-127">
                  Cómo funciona
                </button>
              </li>
              <li data-id="element-128">
                <button onClick={() => scrollToSection('precios')} className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-129">
                  Precios
                </button>
              </li>
              <li data-id="element-130">
                <button onClick={() => scrollToSection('faq')} className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-131">
                  Preguntas
                </button>
              </li>
            </ul>
          </div>
          <div data-id="element-132">
            <h4 className="font-semibold mb-4 text-sm sm:text-base" data-id="element-133">Legal</h4>
            <ul className="space-y-2" data-id="element-134">
              <li data-id="element-135">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-136">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-137">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base" data-id="element-138">
                  Política de Privacidad
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 sm:pt-8 text-center text-gray-400 text-xs sm:text-sm" data-id="element-139">
          <p data-id="element-140">© 2026 Canjee. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}